module.exports = __webpack_public_path__ + "img/az.922fe579.svg";